import { z } from 'zod';

import { TimestampSchema } from './primitives.js';

/**
 * One user's academy progress, at `users/{uid}/academy/{trackId}` (gap G19).
 *
 * Stored server-side so it survives a device change — an operator who set the
 * dashboard up on a tablet and then opens it on a phone should not be told to
 * start learning again.
 *
 * Deliberately just a list of ids. There is no score, no streak and no reward:
 * the academy teaches and never gates, so progress exists to answer "where was
 * I" and nothing else. Anything more would turn reading a help article into a
 * currency worth inflating.
 */
export const AcademyProgressSchema = z.object({
  completedLessonIds: z
    .array(z.string().min(1).max(64))
    .max(200)
    .default([])
    .describe('Lesson ids the user has marked read; order is not meaningful.'),
  updatedAt: TimestampSchema.optional().describe('Last time a lesson was marked.'),
});
export type AcademyProgress = z.infer<typeof AcademyProgressSchema>;
